module.exports = __webpack_public_path__ + "img/n9.9761cb72.jpg";